<template>
  <div class="the-comments" v-inview="{ callback: onInview }">
    <div class="the-comments__loading spinner" v-show="isLoading"><SvgSymbol use="#spinner"/></div>
    <div class="the-comments__plugin fb-comments"
      :data-href="url"
      data-numposts="5"
      data-width="100%"
      data-order-by="reverse_time">
    </div>
  </div>
</template>

<script>
export default {
  name: 'TheComments',
  props: {
    url: { type: String, required: true }
  },
  inject: [ 'isMobile', 'isInApp' ],
  data () {
    return {
      isLoading: false
    }
  },
  methods: {
    onInview () {
      console.log('TheComments inview')
      setTimeout(() => {
        this.isLoading = false
      }, 1000)
      window.FB && window.FB.XFBML.parse()
    }
  },
  mounted () {
    this.isLoading = true
  }
}
</script>

<style lang="scss">
.the-comments {
  position: relative;
  margin: 50px 10px 0 10px;
  min-height: 200px;
  @include rwd($RWD_TABLET_SMALL) {
    margin: 50px 30px 0 30px;
  }
  @include rwd($RWD_TABLET) {
    margin: 60px 50px 0 50px;
  }
  @include rwd($RWD_DESKTOP) {
    max-width: 800px;
    margin: 60px auto 0 auto;
  }
  @include rwd($RWD_DESKTOP_WIDE) {
    max-width: 960px;
  }

  &__loading {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 60px;
    height: 60px;
    transform: translate(-50%, -50%);
  }
}
</style>
